export default "__VITE_ASSET__CUIPjBF4__"